import React from "react"

const HeroSection: React.FC = () => {
  return (
    <div className="w-full mx-auto">
      <div className="relative w-full h-[50vh] sm:h-[60vh] md:h-[70vh] lg:h-[80vh] xl:h-[810px] max-h-[810px]">
        <img
          src="./web-ttmi/homepage/hero-img.png"
          alt="Hero"
          className="w-full h-full object-cover object-left sm:object-center"
        />
      </div>
    </div>
  )
}

export default HeroSection
